import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import {RouterModule} from "@angular/router";
import { appRoutes } from "./routes";
import {ReactiveFormsModule, FormsModule} from '@angular/forms';
import { UserService } from './services/user/user.service';
import { HttpClient, HttpClientModule , HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { JwtService } from './auth/jwt.service';
import { DataSharingService } from './auth/data-sharing.service';

import { HomeComponent } from './home/home.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { FooterComponent } from './shared/layout/footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PreloadComponent } from './shared/animations/preload/preload.component';
import { AdduserComponent } from './sitemodules/vendors/adduser/adduser.component';
import { RoleguardServiceGuard } from './auth/roleguard-service.guard';

import { VendordashboardComponent } from './sitemodules/dashboards/vendordashboard/vendordashboard.component';
import { AdmindashboardComponent } from './sitemodules/dashboards/admindashboard/admindashboard.component';

import { PopoverModule } from 'ngx-popover';
import { SettingsComponent } from './user/settings/settings.component';
import { ProfileComponent } from './user/profile/profile.component';
import { SiteuserComponent } from './sitemodules/siteuser/siteuserview/siteuser.component';
import { SiteusereditComponent } from './sitemodules/siteuser/siteuseredit/siteuseredit.component';
import { SiteuseraddComponent } from './sitemodules/siteuser/siteuseradd/siteuseradd.component';
import { ProductlistComponent } from './sitemodules/products/productlist/productlist.component';
import { ViewproductComponent } from './sitemodules/products/viewproduct/viewproduct.component';
import { EditproductComponent } from './sitemodules/products/editproduct/editproduct.component';
import { AddproductComponent } from './sitemodules/products/addproduct/addproduct.component';
import { CategorylistComponent } from './sitemodules/productcategory/categorylist/categorylist.component';
import { AddcategoryComponent } from './sitemodules/productcategory/addcategory/addcategory.component';
import { EditcategoryComponent } from './sitemodules/productcategory/editcategory/editcategory.component';
import { OrderComponent } from './sitemodules/orders/order/order.component';
import { CartitemsComponent } from './sitemodules/orders/cartitems/cartitems.component';
import { ConfirmorderComponent } from './sitemodules/orders/confirmorder/confirmorder.component';
import { HrdashboardComponent } from './sitemodules/dashboards/hrdashboard/hrdashboard.component';
import { MyordersComponent } from './sitemodules/orders/myorders/myorders.component';
import { ManageordersComponent } from './sitemodules/orders/manageorders/manageorders.component';
import { EditorderComponent } from './sitemodules/orders/editorder/editorder.component';
import { EditorderitemsComponent } from './sitemodules/orders/editorderitems/editorderitems.component';
import { AllordersComponent } from './sitemodules/orders/allorders/allorders.component';
import { PortalsettingComponent } from './sitemodules/portalsettings/portalsetting/portalsetting.component';
import { GeneratereportComponent } from './sitemodules/reports/generatereport/generatereport.component';
import { EditsettingComponent } from './sitemodules/portalsettings/editsetting/editsetting.component';
import { CancelorderComponent } from './sitemodules/orders/cancelorder/cancelorder.component';
import { RepeatComponent } from './sitemodules/orders/repeat/repeat.component';
import { FilledorderComponent } from './sitemodules/orders/vieworders/filledorder/filledorder.component';
import { PendingordersComponent } from './sitemodules/orders/vieworders/pendingorders/pendingorders.component';
import { CancelledordersComponent } from './sitemodules/orders/vieworders/cancelledorders/cancelledorders.component';
import { HrorderuploadComponent } from './sitemodules/reports/hrorderupload/hrorderupload.component';
import { FilledorderreportComponent } from './sitemodules/reports/filledorderreport/filledorderreport.component';
import { DataTablesModule } from 'angular-datatables';
import {DataTableModule} from "angular-6-datatable";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ActiveuserComponent } from './sitemodules/siteuser/userview/activeuser/activeuser.component';
import { InactiveuserComponent } from './sitemodules/siteuser/userview/inactiveuser/inactiveuser.component';
import { EdituserComponent } from './user/edituser/edituser.component';

import {NgxPrintModule} from 'ngx-print';
import { ConfirmrepeatorderComponent } from './sitemodules/orders/confirmrepeatorder/confirmrepeatorder.component';
import { ProductnewsComponent } from './sitemodules/products/productnews/productnews.component';
import { ConfirmedscreenComponent } from './sitemodules/orders/confirmedscreen/confirmedscreen.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    PreloadComponent,
    AdduserComponent,
    VendordashboardComponent,
    AdmindashboardComponent,
    SettingsComponent,
    ProfileComponent,
    SiteuserComponent,
    SiteusereditComponent,
    SiteuseraddComponent,
    ProductlistComponent,
    ViewproductComponent,
    EditproductComponent,
    AddproductComponent,
    CategorylistComponent,
    AddcategoryComponent,
    EditcategoryComponent,
    OrderComponent,
    CartitemsComponent,
    ConfirmorderComponent,
    HrdashboardComponent,
    MyordersComponent,
    ManageordersComponent,
    EditorderComponent,
    EditorderitemsComponent,
    AllordersComponent,
    PortalsettingComponent,
    GeneratereportComponent,
    EditsettingComponent,
    CancelorderComponent,
    RepeatComponent,
    FilledorderComponent,
    PendingordersComponent,
    CancelledordersComponent,
    HrorderuploadComponent,
    FilledorderreportComponent,
    ActiveuserComponent,
    InactiveuserComponent,
    EdituserComponent,
    ConfirmrepeatorderComponent,
    ProductnewsComponent,
    ConfirmedscreenComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    DataTableModule,
    PopoverModule,
    DataTablesModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxPrintModule
  ],
  providers: [UserService, AuthGuard,RoleguardServiceGuard,JwtService,DataSharingService,
    {
      provide : HTTP_INTERCEPTORS,
      useClass : AuthInterceptor,
      multi : true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
